/* eslint-disable */
import {
  SET_MESSAGE,
  CLEAR_MESSAGE
} from './mutation-types'

const state = {
  text: ''
}

const mutations = {
  [SET_MESSAGE](state, payload) {
    state.text = payload
  },
  [CLEAR_MESSAGE](state) {
    state.text = ''
  }
}

const actions = {
  showMessage({ commit }, payload) {
    const text = payload || 'Oops… there was an unexpected error. It has been reported. Please reload and try again.'
    commit(SET_MESSAGE, text)
  },
  hideMessage({ commit }) {
    commit(CLEAR_MESSAGE)
  }
}

export default {
  state,
  mutations,
  actions
}
